import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { Contractor } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number;
  options?: Omit<
    UseMutationOptions<Contractor, Error, void>,
    'mutationKey' | 'mutationFn'
  >;
}

export const useDeleteContractorAssigneeRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useMutation<Contractor, Error, void>(
    [Entities.Contractors, 'delete-assignee', id],
    async () => {
      const { data } = await api.v1AdminContractorsContractorIdAssigneeDelete(id)
      return data as Contractor
    },
    options,
  )
}
